import { PropsWithChildren } from 'react';
import clsx from 'clsx';

import styles from './StickyScrollWrapper.module.scss';

interface StickyScrollWrapperProps extends PropsWithChildren {
  top?: number;
  className?: string;
}

export function StickyScrollWrapper({ top = 100, className, children }: StickyScrollWrapperProps) {
  return (
    <div className={clsx(styles.wrapper, className)} style={{ top: `${top}px`, maxHeight: `calc(100vh - ${top}px)` }}>
      {children}
    </div>
  );
}
